module.exports = __webpack_public_path__ + "img/svg/loader.a274b90807b852f929eafadeeae4cd54.svg";